<template>
  <div>
    <div class="lightbox_video" v-if="visible" @click="show = false">
      <!-- START VIDEO -->
      <div class="col-sm-9" @click.stop="">
        <iframe
          class="modal-iframe-custom"
          :src="this.url"
          frameBorder="0"
          :allowFullScreen="allowFullScreen"
          tabIndex="-1"
        ></iframe>
        <div class="lightbox-title-video">
          <span v-if="!readMoreActivated">{{ this.isi.slice(0, 200)}} <span v-if="(this.isi.length > 200)">...</span></span>
          <a
            class="a-custom"
            v-if="!readMoreActivated && (this.isi.length > 200)"
            @click="activateReadMore"
          >
            &nbsp;Lihat Selengkapnya...</a
          >
          <span v-if="readMoreActivated" v-html="this.isi"></span>
        </div>
      </div>
      <!-- END VIDEO -->
      <!-- <div class="lightbox-subtitle-video">
          <i class="lni lni-user"></i> {{ this.pembuat }} &nbsp;
          <i class="lni lni-calendar"></i> {{ this.waktu_buat }}
        </div> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    url: {
      type: String,
      default: "",
    },
    pembuat: {
      type: String,
      default: "",
    },
    waktu_buat: {
      type: String,
      default: "",
    },
    isi: {
      type: String,
      default: "",
    },
    indeksFromParent: Number,
    visible: Boolean,
  },
  data() {
    return {
      readMoreActivated: false,
      index: 0,
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(visible) {
        this.$emit("clicked", visible);
        this.index = 0;
        this.readMoreActivated = false;
      },
    },
  },
  methods: {
    activateReadMore() {
      this.readMoreActivated = true;
    },
    onKeydown(e) {
      if (this.visible) {
        switch (e.key) {
          case "ArrowRight":
            this.next();
            break;
          case "ArrowLeft":
            this.prev();
            break;
          case "ArrowDown":
          case "ArrowUp":
          case " ":
            e.preventDefault();
            break;
          case "Escape":
            this.hide();
            break;
        }
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.onKeydown);
  },
  unmounted() {
    window.removeEventListener("keydown", this.onKeydown);
  },
};
</script>

<style>
.a-custom {
  color: #f06a25;
  cursor: pointer;
}

.lightbox_video {
  position: fixed;
  z-index: 1000;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
}

.lightbox-arrow {
  position: absolute;
  top: 50%;
  z-index: 515;
  background: rgba(0, 0, 0, 0.3);
}

.lightbox-title-video {
  padding: 2%;
  font-size: small;
  text-align: justify;
  z-index: 515;
  color: white;
  background: rgba(0, 0, 0, 0.8);
  justify-content: center;
  align-items: center;
}

.lightbox-subtitle-video {
  font-size: small;
  position: absolute;
  text-align: justify;
  bottom: 6%;
  z-index: 520;
  color: white;
  justify-content: left;
}

@media screen and (max-width: 600px) {
  .modal-iframe-custom {
    height: calc(25vh - 1px);
    width: 100%;
    box-sizing: border-box;
  }
}

@media screen and (min-width: 750px) {
  .modal-iframe-custom {
    height: calc(40vh - 2px);
    width: calc(80vw - 4px);
    box-sizing: border-box;
  }
}

@media screen and (min-width: 1200px) {
  .modal-iframe-custom {
    height: calc(65vh - 2px);
    width: calc(80vw - 4px);
    box-sizing: border-box;
  }
}

@media screen and (min-width: 1400px) {
  .modal-iframe-custom {
    height: calc(65vh - 4px);
    width: calc(75vw - 10px);
    box-sizing: border-box;
  }
}

.modal-iframe-customs {
  width: 80vw;
  height: 65vh;
}
</style>
